import { render, staticRenderFns } from "./PropertyRental.vue?vue&type=template&id=2a85aafa&scoped=true&"
import script from "./PropertyRental.vue?vue&type=script&lang=js&"
export * from "./PropertyRental.vue?vue&type=script&lang=js&"
import style0 from "./PropertyRental.vue?vue&type=style&index=0&id=2a85aafa&scoped=true&lang=css&"
import style1 from "./PropertyRental.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85aafa",
  null
  
)

export default component.exports